import axios from "axios";
import ApiUrl from "./apiUrl";
import { storage } from "../lib/storage";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getNotificationList = async () => {
  // const token = localStorage.getItem('token') 
    const token = storage.getAccessToken();
  

  try {
    const response = await axios.post(
      `${BASE_URL}${ApiUrl?.notificationList}`,{},{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }  catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch notifications";
      toast.error(errorMessage);
      throw error;
    }
};



// import axios from 'axios'

export const markNotificationAsRead = async (id: string) => {
  // const token = localStorage.getItem('token')
  const token = storage.getAccessToken();


  return axios.post(
    `${BASE_URL}${ApiUrl.notificationUpdate}`,
    { id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  )
}
